module.exports = __webpack_public_path__ + "static/idehal-cover-c7a5bc5900d343660d7609f4d3e0796a.jpg";